module.exports = __webpack_public_path__ + "static/media/goblin_brute_circle.91511bbf.png";